import NoteModal from './NoteModal.vue';

export default NoteModal;
